import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const colorClasses = {
    gray: 'text-gray-900 dark:text-gray-300',
    green: 'text-green-700 dark:text-green-500',
    red: 'text-red-700 dark:text-red-500',
};
export const Label = ({ children, color = 'gray', className, value, ...props }) => {
    return (_jsx("label", { className: classNames('text-sm font-medium', colorClasses[color], className), ...props, children: value ?? children ?? '' }));
};
